import { APP_CONSTANTS, getCurrentUser } from '~/common/explicit-exports';
import { hasUserPermissions } from '~/elc/features/permissions';

const isContentProviderIntegrationEnabled = (contentProviderIntegrationSlug: string) => {
  const activeIntegrations: string[] =
    getCurrentUser().enterprise.activeContentProviderIntegrations?.map((integration) => integration.slug) || [];

  return activeIntegrations.includes(contentProviderIntegrationSlug);
};

const isContentProviderIntegrationSkipPermissioncheckEnabled = (contentProviderIntegrationSlug: string) =>
  getCurrentUser().enterprise.activeContentProviderIntegrations?.find(
    (integration) => integration.slug === contentProviderIntegrationSlug,
  ).contentProviderIntegrationConnection.skipLearnerPermissionCheck;

export const isUdemyIntegrationEnabled = () =>
  isContentProviderIntegrationEnabled(APP_CONSTANTS.TOP_LEVEL_CONTENT_CONTENT_SOURCES.UDEMY);

export const isLinkedInLearningIntegrationEnabled = () =>
  isContentProviderIntegrationEnabled(APP_CONSTANTS.TOP_LEVEL_CONTENT_CONTENT_SOURCES.LINKEDIN_LEARNING);

export const isGo1IntegrationEnabled = () =>
  isContentProviderIntegrationEnabled(APP_CONSTANTS.TOP_LEVEL_CONTENT_CONTENT_SOURCES.GO1);

export const learnerCanAccessUdemy = () =>
  isUdemyIntegrationEnabled() &&
  (hasUserPermissions([APP_CONSTANTS.PERMISSIONS.UDEMY_ACCESS]) ||
    isContentProviderIntegrationSkipPermissioncheckEnabled(APP_CONSTANTS.TOP_LEVEL_CONTENT_CONTENT_SOURCES.UDEMY));

export const learnerCanAccessLinkedInLearning = () =>
  isLinkedInLearningIntegrationEnabled() &&
  (hasUserPermissions([APP_CONSTANTS.PERMISSIONS.LINKEDIN_LEARNING_ACCESS]) ||
    isContentProviderIntegrationSkipPermissioncheckEnabled(
      APP_CONSTANTS.TOP_LEVEL_CONTENT_CONTENT_SOURCES.LINKEDIN_LEARNING,
    ));

export const learnerCanAccessGo1 = () =>
  isGo1IntegrationEnabled() &&
  (hasUserPermissions([APP_CONSTANTS.PERMISSIONS.WORKRAMP_CONTENT_ACCESS]) ||
    isContentProviderIntegrationSkipPermissioncheckEnabled(APP_CONSTANTS.TOP_LEVEL_CONTENT_CONTENT_SOURCES.GO1));
